import React from "react"
import strings from "../localization/strings"

interface IProps {

}
interface IState {

}

export default class NoMatch extends React.Component<IProps, IState> {
    componentDidMount() {
        document.title = strings.Findd_Grandd_Central
    }
    render() {
        return (
            <div
                style={{
                    width: "100%",
                    display: "table",
                    height: "100vh",
                    textAlign: "center"
                }}
            >
                <div
                    style={{
                        fontSize: 35,
                        fontWeight: "bold",
                        display: "table-cell",
                        verticalAlign: "middle"
                    }}
                >
                    {strings.NotFindPage}
                </div>
            </div>
        )
    }
}
